import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  CreateIntegrationData,
  LinkTokenFunctionData,
  LinkTokenResponse,
  MergeHRISIntegration,
  MergeIntegrationConfig
} from '@dadohr/shared/domainTypes/integrations/merge';
import { CF, FS } from '@dadohr/shared/versions';
import { store } from '../../../../../../services/firebase';
import { callFirebaseFunction } from '../../../../../../services/firebaseFunctions';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../../services/firecache/documentListener';

const COLLECTION = FS.mergeIntegrationConfig;
const collection = () => store().collection(COLLECTION);

export const toMergeConfigDoc = generateToDocFn<MergeIntegrationConfig>();

export const mergeConfigStore = createDocumentListenerGetter((orgId) => {
  return collection().doc(orgId);
}, toMergeConfigDoc);

export const useMergeConfig = (orgId: string) => {
  return useDocumentListener(mergeConfigStore(orgId));
};

export const getLinkToken = async (
  orgId: string,
  hrisName: MergeHRISIntegration | null | undefined
) => {
  if (!hrisName) {
    return null;
  }
  const data: LinkTokenFunctionData = { orgId, hrisName };
  const result = await callFirebaseFunction<LinkTokenResponse>(
    CF.merge.getLinkToken,
    data
  );
  return result;
};

export const createIntegration = async (
  orgId: string,
  publicToken: string,
  hris: MergeHRISIntegration | null | undefined
) => {
  if (!hris) {
    throw new Error('An hris parameter is required');
  }

  const data: CreateIntegrationData = { orgId, publicToken, hris };
  return await callFirebaseFunction<LinkTokenResponse>(
    CF.merge.createIntegration,
    data
  );
};

export const removeMergeConfig = (orgId: string) => {
  return collection().doc(orgId).delete();
};
